module.exports = __webpack_public_path__ + "static/media/1009241.4afc6047.png";